import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Invoice } from '@alliance-disposal/transport-types';
import { useSourSearchContext } from '../../context/use-sour-search-context';
///////////////////////////////////////////////
// STATUS PILL COMPONENT
///////////////////////////////////////////////
export const InvoiceStatusPill = ({ status }) => {
    const { environmentOptions } = useSourSearchContext();
    const [label, setLabel] = useState('');
    useEffect(() => {
        if (environmentOptions.application === 'aap') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
        if (environmentOptions.application === 'wayste') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
        // FOR CUSTOMER PORTAL APPLY SPECIAL LABEL AND COLORS
        if (environmentOptions.application === 'customer-portal') {
            setLabel(Invoice.InvoiceStatusLabels[status]);
        }
    }, [environmentOptions.application, status]);
    /////////////////////////////////////////////
    // RENDER;
    /////////////////////////////////////////////
    switch (status) {
        case 'DRAFT':
            return (_jsx("span", { className: "bg-invoiceStatuses-DRAFT-pill-background text-invoiceStatuses-DRAFT-pill-text m-0.5 inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 text-xs outline outline-1", children: _jsx("div", { children: label }) }));
        case 'PENDING':
            return (_jsx("span", { className: "bg-invoiceStatuses-PENDING-pill-background text-invoiceStatuses-PENDING-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'PAID':
            return (_jsx("span", { className: "bg-invoiceStatuses-PAID-pill-background text-invoiceStatuses-PAID-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'VOID':
            return (_jsx("span", { className: "bg-invoiceStatuses-VOID-pill-background text-invoiceStatuses-VOID-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'PARTIALLY_PAID':
            return (_jsx("span", { className: "bg-invoiceStatuses-PARTIALLY_PAID-pill-background text-invoiceStatuses-PARTIALLY_PAID-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'PARTIALLY_VOID':
            return (_jsx("span", { className: "bg-invoiceStatuses-PARTIALLY_VOID-pill-background text-invoiceStatuses-PARTIALLY_VOID-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'PARTIALLY_REFUNDED':
            return (_jsx("span", { className: "bg-invoiceStatuses-PARTIALLY_REFUNDED-pill-background text-invoiceStatuses-PARTIALLY_REFUNDED-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'REFUNDED':
            return (_jsx("span", { className: "bg-invoiceStatuses-REFUNDED-pill-background text-invoiceStatuses-REFUNDED-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        case 'PAST_DUE':
            return (_jsx("span", { className: "bg-invoiceStatuses-PAST_DUE-pill-background text-invoiceStatuses-PAST_DUE-pill-text inline-block overflow-hidden overflow-ellipsis whitespace-nowrap rounded-full px-3 py-0.5 text-xs", children: label }));
        default:
            return _jsx(_Fragment, {});
    }
};
//# sourceMappingURL=invoice-status-pills.js.map